import React from "react";
import { useState } from "react";
import phone from "../Assets/phone1.png";
import { Link } from "react-router-dom";

import {
  PlayCircleFilledRounded,
  ListAltOutlined,
  FavoriteBorderRounded,
  BoltRounded,
} from "@mui/icons-material";

function HomePage() {
  const [dropDown, setDropDown] = useState(false);
  const [dropDown1, setDropDown1] = useState(false);
  const [dropDown2, setDropDown2] = useState(false);
  const [dropDown3, setDropDown3] = useState(false);

  return (
    <div>
      <div className="bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-pink-600 via-fuchsia-600 to-fuchsia-900 bg-center bg-cover bg-no-repeat w-[100%] ">
        <div className="pl-4 py-12 sm:pb-44 sm:pt-20 md:pt-14 md:pb-32 md:pl-8 lg:flex lg:items-center lg:align-middle lg:justify-center lg:gap-x-10  lg:pb-0 lg:pt-20 ">
          <img src={phone} alt="mobile" className="hidden lg:block" />

          <div>
            <h1 className="pr-6 pt-8 text-4xl md:text-5xl leading-normal md:leading-relaxed font-extrabold text-white lg:leading-tight">
              Play millions of songs <br className="hidden md:block" /> and
              podcasts, for free.
            </h1>
            <button className="mt-8 lg:mt-9 bg-white px-6 py-3 lg:py-3 rounded-full text-sm font-semibold uppercase hover:transform translate duration-900 hover:scale-110">
              <Link to="/signup">Get Spotify Free</Link>
            </button>
          </div>
        </div>
      </div>

      <div className="py-8 md:py-20 md:px-4 xl:py-30">
        <div className="text-center text-3xl font-bold md:text-4xl md:font-extrabold">
          Why Spotify?
        </div>

        <div className="mt-8 gap-y-5 md:mt-8 md:grid md:grid-cols-2 md:gap-y-2 xl:grid-cols-4 xl:mt-14 xl:px-32">
          <div className="flex gap-6 items-center px-4 md:my-6 xl:flex-col xl:items-center xl:text-center">
            <div className="p-8 rounded-full bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-pink-600 via-fuchsia-600 to-fuchsia-900">
              <PlayCircleFilledRounded
                fontSize="large"
                className="text-white"
              />
            </div>

            <div>
              <h2 className="font-bold mb-2">Play your favourites.</h2>
              <p className="text-sm font-medium">
                Listen to the songs you love, and discover new music and
                podcasts.
              </p>
            </div>
          </div>

          <div className="flex gap-6 items-center px-4 my-6 xl:flex-col xl:text-center">
            <div className="p-8 rounded-full bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-pink-600 via-fuchsia-600 to-fuchsia-900">
              <ListAltOutlined fontSize="large" className="text-white " />
            </div>
            <div>
              <h2 className="font-bold mb-2">Playlists made easy.</h2>
              <p className="text-sm font-medium">
                We'll help you make playlists. Or enjoy playlists made by music
                experts
              </p>
            </div>
          </div>
          
          <div className="flex gap-6 items-center px-4 my-10 md:my-6 xl:flex-col xl:text-center">
            <div className="p-8 rounded-full bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-pink-600 via-fuchsia-600 to-fuchsia-900">
              <FavoriteBorderRounded fontSize="large" className="text-white " />
            </div>
            <div>
              <h2 className="font-bold mb-2">Make it yours.</h2>
              <p className="text-sm font-medium">
                Tell us what you like, and we'll recommend music for you.
              </p>
            </div>
          </div>
          <div className="flex gap-6 items-center px-4 my-10 md:my-6 xl:flex-col xl:text-center">
            <div className="p-8 rounded-full bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-pink-600 via-fuchsia-600 to-fuchsia-900">
              <BoltRounded fontSize="large" className="text-white " />
            </div>
            <div>
              <h2 className="font-bold mb-2">Save mobile data.</h2>
              <p className="text-sm font-medium">
                To use less data when you play music, turn on Data Saver in
                Settings.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-pink-600 via-fuchsia-600 to-fuchsia-900">
        <div className=" flex flex-col justify-center items-center px-6 py-10 gap-y-5 ">
          <img
            src={phone}
            alt="mobile"
            className="w-[90%] h-[50%] items-center sm:hidden"
          />
          <div className="sm:py-36 sm:space-y-6 text-white text-2xl font-bold text-center items-center sm:text-4xl md:text-5xl">
            <p>It's free. </p>
            <p>No credit card required.</p>
          </div>
        </div>
      </div>

      <div className="py-8 md:py-20 md:px-4 xl:m-auto lg:px-10 xl:px-36">
        <div className="text-center text-2xl font-bold md:text-4xl md:font-extrabold">
          Got questions?
        </div>

        <ul className="px-6 my-8">
          <li
            key={0}
            onClick={() => {
              setDropDown(!dropDown);
              console.log("clicked1");
            }}
          >
            <div className="py-6 px-2 flex justify-between cursor-pointer font-bold transition duration-500 hover:underline hover:bg-slate-20 focus:bg-red-600">
              <p>How do I create a playlist?</p>
              {dropDown ? (
                <ion-icon
                  className="font-bold"
                  name="chevron-up-outline"
                ></ion-icon>
              ) : (
                <ion-icon
                  className="font-bold"
                  name="chevron-down-outline"
                ></ion-icon>
              )}
            </div>

            {dropDown && (
              <div className="text-sm font-medium">
                <p className="mb-4 px-4">
                  Playlists are a great way to save collections of music, either
                  for your own listening or to share.
                </p>
                <p className="px-4">To create one:</p>
                <ul className="list-decimal py-4 px-8">
                  <li> Tap Your Library.</li>
                  <li>
                    Tap
                    <span className=" ml-1 text-green-700 font-semibold">
                      CREATE.
                    </span>
                  </li>
                  <li>Give your playlist a name.</li>
                  <li>Start adding songs (and we'll help you along).</li>
                </ul>
              </div>
            )}
            <hr />
          </li>

          <li
            key={1}
            onClick={() => {
              setDropDown1(!dropDown1);
              console.log("clicked2");
            }}
          >
            <div className="py-6 px-2 flex justify-between cursor-pointer font-bold transition duration-500 hover:underline hover:bg-slate-200 active:bg-slate-200 focus:bg-slate-200">
              <p>How do I activate Data Saver mode?</p>
              {dropDown1 ? (
                <ion-icon
                  className="font-bold"
                  name="chevron-up-outline"
                ></ion-icon>
              ) : (
                <ion-icon
                  className="font-bold"
                  name="chevron-down-outline"
                ></ion-icon>
              )}
            </div>

            {dropDown1 && (
              <div className="text-sm font-medium">
                <ul className="list-decimal py-4 px-8">
                  <li>
                    {" "}
                    Tap{" "}
                    <span className=" ml-1 text-green-700 font-semibold">
                      Home.
                    </span>
                  </li>
                  <li>
                    Tap
                    <span className=" ml-1 text-green-700 font-semibold">
                      Settings
                    </span>
                  </li>
                  <li>
                    {" "}
                    Tap{" "}
                    <span className=" ml-1 text-green-700 font-semibold">
                      Data Saver
                    </span>
                  </li>
                  <li>Switch on Data Saver.</li>
                </ul>
              </div>
            )}
            <hr />
          </li>

          <li
            key={2}
            onClick={() => {
              setDropDown2(!dropDown2);
            }}
          >
            <div className="py-6 px-2 flex justify-between cursor-pointer font-bold transition duration-500 hover:underline hover:bg-slate-200 active:bg-slate-200 focus:bg-slate-200">
              <p>Is it only possible to shuffle play music?</p>
              {dropDown2 ? (
                <ion-icon
                  className="font-bold"
                  name="chevron-up-outline"
                ></ion-icon>
              ) : (
                <ion-icon
                  className="font-bold"
                  name="chevron-down-outline"
                ></ion-icon>
              )}
            </div>

            {dropDown2 && (
              <div className="text-sm font-medium p-4">
                <p>Any playlist with the shuffle icon will play on shuffle.</p>

                <p>
                  Some playlists won't have the shuffle icon, so you can tap any
                  song to play it.
                </p>
              </div>
            )}
            <hr />
          </li>

          <li
            key={3}
            onClick={() => {
              setDropDown3(!dropDown3);
            }}
          >
            <div className="py-6 px-2 flex justify-between cursor-pointer font-bold transition duration-500 hover:underline hover:bg-slate-200 active:bg-slate-200 focus:bg-slate-200">
              <p>Where can I find Podcasts?</p>
              {dropDown3 ? (
                <ion-icon
                  className="font-bold"
                  name="chevron-up-outline"
                ></ion-icon>
              ) : (
                <ion-icon
                  className="font-bold"
                  name="chevron-down-outline"
                ></ion-icon>
              )}
            </div>

            {dropDown3 && (
              <div className="text-sm font-medium p-4">
                <p>
                  Tap{" "}
                  <span className=" ml-1 text-green-700 font-semibold">
                    Search.
                  </span>{" "}
                  Under{" "}
                  <span className=" ml-1 mr-1 text-green-700 font-semibold">
                    Browse All,
                  </span>
                  tap Podcasts.
                </p>
              </div>
            )}
          </li>
        </ul>
      </div>

      <div className="bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-pink-600 via-fuchsia-600 to-fuchsia-900">
        <div className="items-center text-center py-28 sm:py-40">
          <h1
            className="
         text-4xl sm:text-4xl md:text-5xl leading-normal  md:leading-relaxed font-extrabold text-white lg:text-5xl lg:leading-tight"
          >
            Ready? Let's Play.
          </h1>
          <button className="mt-7 lg:mt-9 bg-white px-5 py-2 lg:py-3 rounded-3xl text-sm font-semibold uppercase hover:transform translate duration-800 hover:scale-110">
            <Link to="/signup">Get Spotify Free</Link>
          </button>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
